import type { Speaker } from "./schemas";

/**
 * The one order speakers appear in, on the participant list and on the admin
 * tab alike: the organiser's manual `displayOrder`, then name as the
 * tie-break.
 *
 * Sorted here rather than by an `orderBy` in the query, for the same reason
 * `sortSignals` is: Firestore drops documents missing the ordered field from
 * the result set, and every speaker written before displayOrder existed is
 * missing it. Absent counts as 0, which is also what the admin form writes
 * when the arrows are left alone.
 */
export function sortSpeakers(speakers: Speaker[]): Speaker[] {
  return [...speakers].sort(
    (a, b) =>
      (a.displayOrder ?? 0) - (b.displayOrder ?? 0) ||
      a.name.localeCompare(b.name),
  );
}
